import ReactGA from 'react-ga';

function ga(category, action, label = '') {
  ReactGA.event({ category, action, label });
}

export default ga;
